
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Header from '@/components/Header/Header.vue';
import Topbar from '@/components/Topbar/Topbar.vue';
import Modal from '@kasasa/kloans-common-ui/dist/components/Modal/Modal.vue';
import ErrorBar from '@/components/ErrorBar/ErrorBar.vue';
import { amplifyService } from '@kasasa/kloans-common-ui/dist/consumer-app/services/amplify';
import Loader from '@kasasa/kloans-common-ui/dist/consumer-app/components/Loader/Loader.vue';

@Component({
	components: {
		Header,
		Topbar,
		Modal,
		ErrorBar,
		Loader,
	},
})
export default class App extends Vue {
	get showModal() {
		return this.$store.getters.showModal;
	}

	get modalMessage() {
		return this.$store.getters.modalText;
	}

	get showWell() {
		return this.$store.getters.showWell;
	}

	get hasError() {
		return this.$store.getters.hasError;
	}

	get hideConsumerLogin() {
		return this.$store.getters.hideConsumerLogin;
	}

	get showLoader() {
		return this.$store.getters.showLoader;
	}

	public async created() {
		await this.loadEnvironment();
	}

	private closeAppModal() {
		this.$store.commit('toggleModal');
	}

	private async loadEnvironment() {
		try {
			await amplifyService.initialize();
		} catch (error) {
			await this.$store.dispatch('showError', 'An error occurred, please reload the page and try again.');
		} finally {
			this.$store.commit('setLoaderState', false);
		}
	}
}
